'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          id = _props.id,
          title = _props.title,
          checked = _props.checked;


      return _react2.default.createElement(
        'span',
        { className: 'Checkbox' },
        _react2.default.createElement('input', { type: 'checkbox', id: id, checked: checked, onChange: action }),
        _react2.default.createElement(
          'label',
          { htmlFor: id },
          _react2.default.createElement(
            'span',
            { className: 'box ' + (checked && 'checked') },
            checked && _react2.default.createElement(_.Icon, { name: 'checkmark' })
          ),
          title
        )
      );
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
  /**
   * Action used as the onChange handler on the checkbox.
   */
  action: _propTypes2.default.func,
  /**
   * Whether the checkbox is checked.
   */
  checked: _propTypes2.default.bool,
  /**
   * The ID of the checkbox.
   */
  id: _propTypes2.default.string.isRequired,
  /**
   * The title of the checkbox.
   */
  title: _propTypes2.default.string.isRequired
};
Checkbox.defaultProps = {
  checked: false
};
exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Checkbox.js
// module id = 263
// module chunks = 0